/**
 * Cloud tenant SPA entry point.
 *
 * Uses ThemeProvider from the shared UI library. No Sentry integration
 * in cloud SaaS — telemetry is handled server-side.
 */
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from '@ensafely/checker-ui'
import { App } from './App'

// Import styles from the shared UI library
import '@ensafely/checker-ui/styles.css'

// Capture Google Ads attribution on initial load so we can still gate the
// Purchase conversion event later even if the gclid query param is stripped
// by the router before the user reaches the billing page. gtag itself also
// stores the gclid in the _gcl_aw cookie; sessionStorage is a belt-and-
// braces backup in case third-party cookies are blocked.
try {
  const params = new URLSearchParams(window.location.search)
  const gclid = params.get('gclid')
  if (gclid) {
    sessionStorage.setItem('ensafely_gclid', gclid)
  }
} catch {
  /* sessionStorage unavailable — ignore */
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>
)
